var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.51398V11.514M31.5 2.51398V11.514M2.25 20.514H42.75M13.5 29.514H13.5225M22.5 29.514H22.5225M31.5 29.514H31.5225M13.5 38.514H13.5225M22.5 38.514H22.5225M31.5 38.514H31.5225M6.75 7.01398H38.25C40.7353 7.01398 42.75 9.0287 42.75 11.514V43.014C42.75 45.4993 40.7353 47.514 38.25 47.514H6.75C4.26472 47.514 2.25 45.4993 2.25 43.014V11.514C2.25 9.0287 4.26472 7.01398 6.75 7.01398Z",
    stroke: "#08387C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal);
export default __webpack_public_path__ + "static/media/cal.0f642255cb71646886caa08391f4e807.svg";
export { ForwardRef as ReactComponent };